import Vue from 'vue';
import Router from 'vue-router';
import { ROUTE_NAMES } from '@/router/route-names';

Vue.use(Router);

// экспортируем функцию-фабрику для создания экземпляров нового роутера
export function createRouter () {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'MainPage',
        component: () => import(/* webpackChunkName: 'home' */ '@/pages/home.vue'),
      },
      {
        path: '/stores',
        name: 'Stores',
        component: () => import(/* webpackChunkName: 'stores' */ '@/pages/stores.vue'),
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import(/* webpackChunkName: 'search' */ '@/pages/search.vue'),
      },
      {
        path: '/delivery',
        name: 'Delivery',
        component: () => import(/* webpackChunkName: 'delivery' */ '@/pages/info/delivery.vue'),
      },
      {
        path: '/gift_card',
        name: 'GiftCard',
        component: () => import(/* webpackChunkName: 'giftCard' */ '@/pages/info/gift_card.vue'),
      },
      {
        path: '/payment',
        name: 'Payment',
        component: () => import(/* webpackChunkName: 'payment' */ '@/pages/info/payment.vue'),
      },
      {
        path: '/contacts',
        name: 'Contacts',
        component: () => import(/* webpackChunkName: 'contacts' */ '@/pages/info/contacts.vue'),
      },
      {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: 'about' */ '@/pages/info/about.vue'),
      },
      {
        path: '/razmery_odezhdy',
        name: 'Sizes',
        component: () => import(/* webpackChunkName: 'sizes' */ '@/pages/info/sizes.vue'),
      },
      {
        path: '/obmen_i_vozvrat',
        name: 'ExchangeAndReturns',
        component: () => import(/* webpackChunkName: 'exchangeAndReturns' */ '@/pages/info/obmen_i_vozvrat.vue'),
      },
      {
        path: '/voprosi_i_otveti',
        name: 'FAQ',
        component: () => import(/* webpackChunkName: 'faq' */ '@/pages/info/faq.vue'),
      },
      {
        path: '/fun-club',
        name: 'FunClub',
        component: () => import(/* webpackChunkName: 'club' */ '@/pages/info/club.vue'),
      },
      {
        path: '/news',
        name: 'News',
        component: () => import(/* webpackChunkName: 'news' */ '@/pages/news.vue'),
      },
      {
        path: '/news/:id',
        name: 'Publication',
        component: () => import(/* webpackChunkName: 'publication' */ '@/pages/publication.vue'),
      },
      {
        path: '/catalog/:id',
        name: 'Catalog',
        component: () => import(/* webpackChunkName: 'catalog' */ '@/pages/catalog.vue'),
      },
      {
        path: '/catalog/:id/*',
        name: 'Category',
        component: () => import(/* webpackChunkName: 'category' */ '@/pages/category.vue'),
      },
      {
        path: '/product/:id',
        name: ROUTE_NAMES.Product,
        component: () => import(/* webpackChunkName: 'product' */ '@/pages/product.vue'),
      },
      {
        path: '/checkout',
        name: 'Checkout',
        component: () => import(/* webpackChunkName: 'checkout' */ '@/pages/checkout.vue'),
      },
      {
        path: '/thankyoupage',
        name: 'TYP',
        component: () => import(/* webpackChunkName: 'thankyou' */ '@/pages/thankyou.vue'),
      },
      {
        path: '/account',
        component: () => import(/* webpackChunkName: 'accout' */ '@/pages/account/account.vue'),
        children: [
          {
            path: '',
            name: 'AccountProfile',
            component: () => import(/* webpackChunkName: 'accoutProfile' */ '@/pages/account/profile.vue'),
          },
          {
            path: 'club',
            name: 'AccountClub',
            component: () => import(/* webpackChunkName: 'accoutClub' */ '@/pages/account/club.vue'),
          },
          {
            path: 'orders',
            name: 'AccountOrders',
            component: () => import(/* webpackChunkName: 'accoutOrder' */ '@/pages/account/orders.vue'),
          },
          {
            path: 'addresses',
            name: 'AccountAddresses',
            component: () => import(/* webpackChunkName: 'accoutAddresses' */ '@/pages/account/addresses.vue'),
          },
          {
            path: 'promotions',
            name: 'AccountPromotions',
            component: () => import(/* webpackChunkName: 'accoutPromotions' */ '@/pages/account/promotions.vue'),
          },
          {
            path: 'favorites',
            name: 'AccountFavorites',
            component: () => import(/* webpackChunkName: 'accoutFavorites' */ '@/pages/account/favorites.vue'),
          },
          {
            path: 'subscribes',
            name: 'AccountSubscribes',
            component: () => import(/* webpackChunkName: 'accoutSubscribes' */ '@/pages/account/subscribes.vue'),
          },
          {
            path: 'logout',
            name: 'AccountLogout',
            component: () => import(/* webpackChunkName: 'accoutLogout' */ '@/pages/account/logout.vue'),
          },
        ]
      },
        // Статические страницы
      ...['/public_ofert', '/agreement', '/club_rules','/content_rules'].map(path => ({
            path,
            name: path,
            component: () => import(/* webpackChunkName: 'staticPage' */ '@/pages/static_page.vue')
          })
      ),
    ],
  });
}
